import axios, { AxiosRequestConfig, CancelTokenSource } from 'axios';
import { authRequestInterceptor, authResponseErrorInterceptors, authResponseSuccessInterceptors } from '../interceptors/auth.interceptor';
import {
   cancelTokenRequestInterceptor,
   cancelTokenResponseErrorInterceptors,
   cancelTokenResponseSuccessInterceptors,
} from '../interceptors/cancel-token.interceptor';
import { errorResponseErrorInterceptor, errorResponseSuccessInterceptor } from '../interceptors/error.interceptor';
import { localizationRequestInterceptor } from '../interceptors/localization.interceptor';
import { versionResponseInterceptor } from '../interceptors/version.interceptor';

export interface CustomAxiosRequestConfig extends AxiosRequestConfig {
   cancelable?: boolean;
   skipErrorNotification?: boolean;
}

const indexedDbName = `NxtFormAPICache[${import.meta.env.VITE_APP_ENV}]`;

const cancelTokenDict: { [request: string]: CancelTokenSource } = {};

function addCancelToken(request?: string, cancelToken?: CancelTokenSource) {
   if (!request || !cancelToken) return;
   cancelTokenDict[request] = cancelToken;
}
function removeCancelToken(request?: string) {
   if (!request) return;
   if (cancelTokenDict[request]) delete cancelTokenDict[request];
}

const baseConfig: AxiosRequestConfig = {
   baseURL: import.meta.env.VITE_APP_API_BASE_URL_DATA,
};

const cacheConfig: AxiosRequestConfig = {
   headers: {
      'Cache-Control': 'force-cache',
   },
};

const http = axios.create(baseConfig);

//request interceptors
http.interceptors.request.use(authRequestInterceptor);
http.interceptors.request.use(localizationRequestInterceptor);
http.interceptors.request.use(cancelTokenRequestInterceptor);

//response interceptors
http.interceptors.response.use(authResponseSuccessInterceptors, authResponseErrorInterceptors);
http.interceptors.response.use(versionResponseInterceptor);
http.interceptors.response.use(errorResponseSuccessInterceptor, errorResponseErrorInterceptor);
http.interceptors.response.use(cancelTokenResponseSuccessInterceptors, cancelTokenResponseErrorInterceptors);

export { addCancelToken, cacheConfig, cancelTokenDict, http, indexedDbName, removeCancelToken };

export const HOURS_24 = 86400000;
export const HOURS_12 = 43200000;
export const HOURS_6 = 21600000;
export const HOURS_3 = 10800000;
